import React from "react";
import { cn } from "@/lib/utils";

type MetricCardsGridColumns = 2 | 4;

interface MetricCardsGridProps {
  children: React.ReactNode;
  columns?: MetricCardsGridColumns;
  className?: string;
}

const columnsClassName: Record<MetricCardsGridColumns, string> = {
  2: "sm:grid-cols-[repeat(2,240px)]",
  4: "md:grid-cols-[repeat(2,240px)] xl:grid-cols-[repeat(4,240px)]",
};

export const MetricCardsGrid: React.FC<MetricCardsGridProps> = ({
  children,
  columns = 2,
  className,
}) => {
  return (
    <div
      className={cn(
        "grid grid-cols-1 gap-3 justify-items-start",
        columnsClassName[columns],
        className,
      )}
    >
      {children}
    </div>
  );
};
